import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Formik, Form, ErrorMessage } from 'formik';
import useTranslation from 'next-translate/useTranslation';
import { style, API } from '../../api';
import { CheckBox } from '../common/Inputs';
import { GradientButton } from '../common/Buttons';
import { Text, Red, Notice } from '../common/Text';
import { Input } from '../../VuexyDesign/atoms/_index';
import CentralizeButton from '../../VuexyDesign/atoms/CentralizeButton';

const UserReport = ({ id, close }: { close: () => void; id: number }) => {
  const [jopa, setJopa] = useState(false);
  const { t } = useTranslation('modals');
  const [placeholder, setPlaceholder] = useState<string>();
  useEffect(() => {
    setPlaceholder(t('modals:placeholders.reportMessage') as string);
  }, []);

  return jopa ? (
    <CenterCol>
      <Notice>{t('modals:userReported') as string}</Notice>
      <GradientButton onClick={close}>
        {t('modals:ok') as string}
      </GradientButton>
    </CenterCol>
  ) : (
    <Col>
      <Title>{t('modals:reportUser') as string}</Title>
      <Formik
        initialValues={{
          email: '',
          phone_number: '',
          body: '',
          information_check: false,
          terms_check: false,
        }}
        onSubmit={async (values, { setSubmitting, setErrors }) => {
          setSubmitting(true);
          try {
            await API.user.reportUser(id, values);
            setJopa(true);
          } catch (error: any) {
            if (error.response?.data) setErrors(error.response?.data?.data);
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {({ isSubmitting, setFieldValue, values }) => (
          <Form>
            <Col>
              <Row>
                <Input
                  type="text"
                  name="email"
                  placeholder={t('modals:placeholders.email') as string}
                />
                <ErrorMessage name="email" component={ErrorLabel} />
              </Row>
              <Row>
                <Input
                  type="text"
                  name="phone_number"
                  placeholder={t('modals:placeholders.phoneNumber') as string}
                />
                <ErrorMessage name="phone_number" component={ErrorLabel} />
              </Row>
              <Row>
                <Input type="text" name="body" placeholder={placeholder} />
                <ErrorMessage name="body" component={ErrorLabel} />
              </Row>
              <Row>
                <CheckBox
                  name="terms_check"
                  checked={values.terms_check}
                  onClick={() =>
                    setFieldValue('terms_check', !values.terms_check)
                  }
                  disabled={isSubmitting}
                />
                <Text>
                  {t('modals:agreeWithTerms') as string}{' '}
                  <Red>{t('modals:informationTerms') as string}</Red>
                </Text>
                <ErrorMessage name="terms_check" component={ErrorLabel} />
              </Row>
              <Row>
                <CentralizeButton
                  type="submit"
                  color="primary"
                  disabled={isSubmitting}
                  text={t('modals:report') as string}
                  size="sm"
                />
              </Row>
            </Col>
          </Form>
        )}
      </Formik>
    </Col>
  );
};

export default UserReport;

const ErrorLabel = styled.div`
  color: red;
  padding: 5px 0 0 25px;
  flex-basis: 100%;
`;

const Title = styled.h4`
  margin: 0 0 10px 0;
  padding: 0;
  font-size: 27px;
  font-weight: 700;
  color: ${style.black};
`;

const Col = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const CenterCol = styled(Col)`
  align-items: center;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 10px;
  flex-wrap: wrap;

  ${Text} {
    margin-bottom: 0px;
    padding-left: 5px;
  }

  button {
    margin-top: 20px;
  }
`;
